import {
    CORDOVA_INIT_LIB,
    CORDOVA_LIB,
} from '@perpay-web/fintech/constants/urls';
import { getIsReactNative } from '@perpay-web/native-client/getIsReactNative';
import { noop } from '@perpay-web/utils/noop';
import { loadThirdPartyScript } from '@perpay-web/utils/scriptUtils';
import { isAppBrowserAgent } from '@perpay-web/utils/userAgentUtils';

const installCordovaBase = () => loadThirdPartyScript(CORDOVA_LIB);

const installCordovaInit = () => loadThirdPartyScript(CORDOVA_INIT_LIB);

const noopPromise = new Promise(noop);

let cachedAppPromise = null;

/** @deprecated should be removed once enough users are no longer on the cordova app */
export const getCordovaApp = () => {
    if (getIsReactNative()) {
        return noopPromise;
    }

    if (!isAppBrowserAgent()) {
        // This promise will never resolve
        return noopPromise;
    }

    // Return the cached app reference instead of reinitializing
    if (cachedAppPromise) {
        return cachedAppPromise;
    }

    cachedAppPromise = installCordovaBase()
        .then(() => installCordovaInit())
        .then(() => window.CordovaApp());
    return cachedAppPromise;
};
